import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { PortalTemplatesService } from '../../infrastructure/services/portalTemplates.service';
import { ItemGeneralListado } from '../../helpers/components/itemClasses/itemListadoGeneral.class';
import { Observable } from 'rxjs/Observable';

@Component({
  templateUrl: './listado.pages.component.html',
})
export class ListadoPagesComponent implements OnInit {
  codSistema: string;
  codPortal: string;
  pages: Observable<ItemGeneralListado[]>;
  itemOver;
  constructor(private aRoute: ActivatedRoute, private portaService: PortalTemplatesService ) { }

  ngOnInit() {
    this.aRoute.params.subscribe((params: Params) => {
      this.codSistema = params['codsistema'];
      this.codPortal = params['codPortal'];

      this.pages = this.portaService.GetPagesByCodPortal(this.codPortal);
    });
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/siteTemplates/listado.pages.component.ts